import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";

const LocationMap = () => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <>
            <Box 
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.965637518207!2d79.85413821101764!3d6.894713718708581!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25bdec6bd5397%3A0x7dff280444d06506!2s46%20Lauries%20Rd%2C%20Colombo%2000400!5e0!3m2!1sen!2slk!4v1755696099276!5m2!1sen!2slk" 
                        width='100%'
                        height={isMobile ? "200" : "450"} 
                        style={{
                            border: 0
                        }}
                        loading="lazy" 
                    ></iframe>
                </Stack>
            </Box>
        </>
    );
}

export default LocationMap;